import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

const FilterCheckbox = (props) => {
  const { filter, triggerFilters, clear, defaultValue } = props

  const { register, setValue } = useFormContext()

  const [selected, setSelected] = useState(false)

  const filterRef = useRef()

  useEffect(() => {
    const checkbox = filterRef.current
    if (checkbox?.checked !== defaultValue) {
      setValue(filter.name, defaultValue)
      setSelected(defaultValue)
    }
  }, [defaultValue])

  const onChange = () => {
    const checkboxChecked = filterRef?.current?.checked
    setSelected(checkboxChecked)
    setValue(filter.name, checkboxChecked)
    triggerFilters()
  }

  const resetFilter = () => {
    setSelected(false)
    setValue(filter.name, false)
    triggerFilters()
  }

  useEffect(() => {
    if (clear) resetFilter()
  }, [clear])

  return (
    <div className={`FilterCheckbox ${selected ? 'is-selected' : ''}`}>
      <label className="FilterCheckbox-label" htmlFor={filter.id}>
        <div className="FilterCheckbox-text">
          <span className="FilterCheckbox-title">{filter.title}</span>
        </div>
        <div className="FilterCheckbox-icon"></div>
        <div className="FilterCheckbox-input">
          <input
            type="checkbox"
            name={filter.name}
            id={filter.id}
            {...register(filter.name)}
            ref={filterRef}
            onChange={() => onChange()}
          />
        </div>
      </label>
    </div>
  )
}

FilterCheckbox.propTypes = {
  filter: PropTypes.object,
  triggerFilters: PropTypes.func,
  clear: PropTypes.any,
  defaultValue: PropTypes.bool
}

export default FilterCheckbox
